import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        language: 'sl-si',
        token: ''
    },
    getters: {
    },
    mutations: {
        setLanguage(state, lang) {
            state.language = lang;
        },
        setToken(state, token: string){
            state.token = token;
        }
    },
    actions: {

    },
});
